import React from "react"
import ScrollPosition from "../../hook/ScrollPosition";

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const F1floor = () => {
   const scrollPosition = ScrollPosition()
   return (
      <div className='Floor flexCenter'>
         <img src={require("../../img/shop/1F.png")} alt="" />
         <div className={`${scrollPosition >= 550 ? 'originPosition' : ''}`}>
            <h2>site.A     CAFÉ EPHEMERA</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/ephemera-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/ephemera-02.jpg")} alt="슬라이드 이미지2" /> </SwiperSlide>
            </Swiper>
            <img src={require("../../img/logo/logo_ephemera.png")} alt='' style={{width:'150px'}} />
            <p>한 장으로는 날짜가 지난 티켓이지만 여러 장이 모여 수집품이되듯이, 단편만 보면 보잘것없어 보이는 하루도 여러 날이 모여당신의 인생을 이루는 것과 같은 맥락으로 읽힙니다.</p>
            <p>Ephemera에서는 꼭 특별하지 않은 하루더라도 소중한 하루가 모여일상이 되고 그 일상이 쌓여서 당신의 인생이 되는 모습을 상상해볼수 있습니다.</p>
            <p className="mb60">이페메라의 모든 메뉴는 매일 주방에서 직접 만들고 있습니다.</p>

            <span>Directions: A동 1층</span>
            <span className="mb20">Opening hours: 11:00AM ~ 20:00PM</span>
            <a className="link-arrow" href="noscrupt:">MENU</a>
            <a className="link-arrow" href="noscrupt:">E,SHOP</a>
            <a className="link-arrow" href="noscrupt:">INSTAGRAM</a>
         </div>
         <div className={`${scrollPosition >= 1700 ? 'originPosition' : ''}`}>
            <h2>site.B     DDMMYY</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/ddmmyy-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
            </Swiper>
            <p>DDMMYY는 일 Day, 월 Month, 년도 Year 날짜를 표기하는 방식에서 착안한 팝업 공간으로 날짜에 따라 바뀌는 새로운 이야기가 소개합니다. </p>
            <p className="mb60">시간에 따라 변화하는 콘텐츠로 한정된 공간의 한계를 극복하여 더 많은 이야기를 전달하고 있습니다.</p>

            <a className="link-arrow" href="noscrupt:">INFORMATION</a>
         </div>
         <div className={`${scrollPosition >= 3000 ? 'originPosition' : ''}`}>
            <h2>site.C     르시뜨피존(LE SITE PIGEON)</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/le-site-pigeon-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/le-site-pigeon-02.jpg")} alt="슬라이드 이미지2" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/le-site-pigeon-03.jpg")} alt="슬라이드 이미지2" /> </SwiperSlide>
            </Swiper>
            <img src={require("../../img/logo/logo_le-site-pigeon.png")} alt='' style={{width:'150px'}} />
            <p>Life style</p>
            <p>사물의 발견 - 가치의 공유 - 취향의 소통 <br />
            우리는 우리가 놓쳐선 안될 삶의 의식을 바탕으로 보다 새롭고 다채로운 주거 문화를 살펴 이를 함께 공유합니다.</p>
            <p className="mb60">결코 지루하지 않은 우리 삶의 유희를 관찰하고, 우리의 환경 속 다양한 생각과 형태를 드러내며 표현합니다. 우리는 합리적이며 올바른 의식을 끌어당겨 우리의 가정, 우리의 의식, 우리의 삶의 지향점을 아우를 수 있도록 함께 공유하고 나누어 보다 유익하고 건강한 미래를 준비합니다.</p>

            <span>Directions: C동 1층</span>
            <span className="mb20">Opening hours: 월-일 11AM ~ 8PM</span>
            <a className="link-arrow" href="noscrupt:">INSTAGRAM</a>
            <a className="link-arrow" href="noscrupt:">E,MAIL</a>
         </div>
      </div>
   )
}

export default F1floor
